import React, { useEffect, useState } from "react";
import { getProjectActivities } from "../service";
import { Table } from "reactstrap";

const ActivityLog = ({ projectId, getRelativeTime }) => {
  const [activities, setActivities] = useState([]);
  const actionMapper = {
    create_project: {
      render: ({ project }) => (
        <p className="m-0">
          Project <b>{project}</b> created.
        </p>
      ),
    },
    clone_project: {
      render: ({ project }) => (
        <p className="m-0">
          Project <b>{project}</b> cloned from another project.
        </p>
      ),
    },
    delete_project: {
      render: ({ project }) => (
        <p className="m-0">
          Project <b>{project}</b> deleted.
        </p>
      ),
    },
    create_room: {
      render: ({ path }) => (
        <p className="m-0">
          Room <b>{path.room_name}</b> added.
        </p>
      ),
    },
    delete_room: {
      render: ({ path }) => (
        <p className="m-0">
          Room <b>{path.room_name}</b> deleted.
        </p>
      ),
    },
    create_section: {
      render: ({ path }) => (
        <p className="m-0">
          Section <b>{path.group_name}</b> added to the room {path.room_name}.
        </p>
      ),
    },
    delete_section: {
      render: ({ path }) => (
        <p className="m-0">
          Section <b>{path.group_name}</b> deleted from the room{" "}
          {path.room_name}.
        </p>
      ),
    },
    create_order_item: {
      render: ({ path }) => (
        <p className="m-0">
          Module <b>{path.order_item_name}</b> added to {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    delete_order_item: {
      render: ({ path }) => (
        <p className="m-0">
          Module <b>{path.order_item_name}</b> deleted from {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    update_order_item_height: {
      render: ({ path, change }) => (
        <p className="m-0">
          {path.order_item_name} <b>height</b>{" "}
          {change[0] && change[1]
            ? `changed from ${change[0]} to ${change[1]} `
            : change[0]
            ? `cleared (was ${change[0]}) `
            : `set to ${change[1]} `}
          in {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    update_order_item_width: {
      render: ({ path, change }) => (
        <p className="m-0">
          {path.order_item_name} <b>width</b> changed from {change[0]} to{" "}
          {change[1]} in {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    update_order_item_depth: {
      render: ({ path, change }) => (
        <p className="m-0">
          {path.order_item_name} <b>depth</b>{" "}
          {change[0] && change[1]
            ? `changed from ${change[0]} to ${change[1]} `
            : change[0]
            ? `cleared (was ${change[0]}) `
            : `set to ${change[1]} `}
          in {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    update_order_item_property: {
      render: ({ path, change, key }) => (
        <p className="m-0">
          {path.order_item_name} <b>{key}</b>{" "}
          {change[0] && change[1]
            ? `changed from ${change[0]} to ${change[1]} `
            : change[0]
            ? `cleared (was ${change[0]}) `
            : `set to ${change[1]} `}
          in {path.room_name}
          {path.group_name ? ` -> ${path.group_name}` : ""}.
        </p>
      ),
    },
    refresh_price: {
      render: ({ change }) => (
        <p className="m-0">
          Price changed from <b>{Math.round(change[0])}</b> to{" "}
          <b>{Math.round(change[1])}</b>.
        </p>
      ),
    },
    refresh_delivery_date: {
      render: () => <p className="m-0">Delivery date has been refreshed.</p>,
    },
  };

  useEffect(() => {
    getProjectActivities(projectId).then((res) =>
      setActivities(res.activities)
    );
  }, []);

  const getAction = (activity) =>
    actionMapper[activity.action].render(activity);

  return (
    <Table bordered>
      <thead>
        <tr>
          <th>Action</th>
          <th>User</th>
          <th>Last Activity</th>
        </tr>
      </thead>
      <tbody>
        {activities.map((activity, index) => (
          <tr key={index}>
            <td>{getAction(activity)}</td>
            <td>{activity.user}</td>
            <td>{getRelativeTime(activity.created_at)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ActivityLog;
